import { styled } from '@fluentui/react';
import { NavBase } from './nav.base';
import { getNavStyles } from './nav.style';
export const Nav = styled(NavBase, getNavStyles, undefined, {
    scope: 'M365LeftNav',
    // Note the slightly different scope name from component name
    // This one will directly conflict with Fluent Nav otherwise
});
//# sourceMappingURL=nav.js.map